import { Text, TextProps, useTheme } from 'bold-ui'

export function LinhaTooltipGrafico(props: TextProps) {
  const theme = useTheme()
  return <Text component='p' style={{ color: theme.pallete.gray.c100 }} {...props} />
}
